import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppForm, AppFormItem } from 'shared/UI/UIKit/Form';
import { AppInput } from 'shared/UI/UIKit/Input';
import { AppMultipleSelect, AppSelect } from 'shared/UI/UIKit/Select';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppInputNumber } from 'shared/UI/UIKit/InputNumber';
import { getSiderScrollPopupContainer } from 'shared/UI/UIKit/Sider';
import type { TableFilterField } from './types';
import { TableFilterFieldType } from './types';
import { useTableFilterForm } from './use-table-filter-form';
import styles from './TableFilterForm.module.scss';

interface TableFilterFormProps {
  fields: TableFilterField[];
  fieldsValue?: Record<string, any>;
  onSubmit: (values: Record<string, any>) => void;
  onClose: () => void;
  onLoadOptions?: (fieldName: string) => void;
}

const getJSXField = (
  field: TableFilterField,
  onSelectDropdownVisible: (field: TableFilterField, open: boolean) => void,
) => {
  switch (field.type) {
    case TableFilterFieldType.INPUT:
      return <AppInput placeholder={field.placeholder || `Введите ${field.label}`} />;

    case TableFilterFieldType.SELECT:
      return (
        <AppSelect
          allowClear
          className={field.className}
          dropdownClassName={field.dropdownClassName}
          dropdownMatchSelectWidth={field.dropdownMatchSelectWidth}
          getPopupContainer={getSiderScrollPopupContainer}
          options={field.options || []}
          placeholder={field.placeholder || `Выберите ${field.label}`}
          loading={field.loading}
          onDropdownVisibleChange={(open) => onSelectDropdownVisible(field, open)}
        />
      );

    case TableFilterFieldType.MULTI_SELECT: {
      return (
        <AppMultipleSelect
          allowClear
          className={field.className}
          dropdownClassName={field.dropdownClassName}
          dropdownMatchSelectWidth={field.dropdownMatchSelectWidth}
          getPopupContainer={getSiderScrollPopupContainer}
          options={field.options || []}
          placeholder={field.placeholder || `Выберите ${field.label}`}
          loading={field.loading}
          style={{ height: 'auto', minHeight: '4rem' }}
        />
      );
    }

    case TableFilterFieldType.NUMBER:
      return (
        <AppInputNumber
          min={field?.min}
          precision={field?.precision}
          placeholder={field.placeholder || `Введите ${field.label}`}
        />
      );
  }
};

export const TableFilterForm = (props: TableFilterFormProps) => {
  const {
    state: { form },
    methods: { onFormSubmit, onReset, onSelectDropdownVisible },
  } = useTableFilterForm(props);
  return (
    <AppFlex className={styles['table-filter']}>
      <AppForm form={form} className={styles.form}>
        {props.fields.map((field) => (
          <AppFormItem
            key={field.key}
            label={field.label}
            labelColor="gray"
            size="xxl"
            name={field.name}
          >
            {getJSXField(field, onSelectDropdownVisible)}
          </AppFormItem>
        ))}
      </AppForm>
      <AppFlex
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        className={styles.actions}
      >
        <AppButton onClick={onFormSubmit}>Применить</AppButton>
        <AppButton onClick={onReset} type="outline">
          Сбросить всё
        </AppButton>
      </AppFlex>
    </AppFlex>
  );
};
